import PropTypes from 'prop-types';
import joinNodes from '../../utils/react/joinNodes';

export default function ArticlePublicationInfo({ pageRange, publicationName, publicationDate }) {
  const result = [];

  if (publicationName) {
    result.push(<strong key="publication-name" className="u-text-italic ">{publicationName}</strong>);
  }

  if (publicationDate) {
    result.push(publicationDate);
  }

  if (pageRange.length === 1) {
    result.push(`Page ${pageRange[0]}`);
  } else if (pageRange.length === 2) {
    result.push(`Pages ${pageRange[0]}-${pageRange[1]}`);
  }

  const components = joinNodes(result, ' • ');

  return (
    <div className="text-xs">
      {components}
    </div>
  );
}

ArticlePublicationInfo.propTypes = {
  publicationDate: PropTypes.string,
  publicationName: PropTypes.string,
  pageRange: PropTypes.arrayOf(PropTypes.string),
};

ArticlePublicationInfo.defaultProps = {
  publicationDate: undefined,
  publicationName: undefined,
  pageRange: [],
};
